import qs from 'querystring'
import _ from 'lodash'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/order-jzhz'

const NAME_PREFIX = 'ORDER_JZHZ';

const DEFAULT_SIZE = 10

const RECEIVE_LIST = `${NAME_PREFIX}_RECEIVE_LIST`

const RECEIVE_DETAIL = `${NAME_PREFIX}_RECEIVE_DETAIL`

const RECEIVE_FLOW_DETAIL = `${NAME_PREFIX}_RECEIVE_FLOW_DETAIL`

export const CHANGE_PAGE = `${NAME_PREFIX}_CHANGE_PAGE`

export const CHANGE_QUERY = `${NAME_PREFIX}_CHANGE_QUERY`

export const SHOW_MODAL = `${NAME_PREFIX}_SHOW_MODAL`

export const HIDE_MODAL = `${NAME_PREFIX}_HIDE_MODAL`

export const CHANGE_FILTER_LIST = `${NAME_PREFIX}_CHANGE_FILTER_LIST`

export const RECEIVE_STATUS_DETAIL = `${NAME_PREFIX}_RECEIVE_STATUS_DETAIL`

function trimForm(formData) {
    const newFormData = {};
    Object.keys(formData).forEach(key=>{
        const value = formData[key];
        if (typeof(value) === 'string') {
            newFormData[key] = value.trim();
        } else {
            newFormData[key] = value;
        }
    })
    newFormData.indexField = ['aliwangwang', 'phone', 'email', 'domain', 'customerFtpUrl','customerFtpName', 'customerFtpPassword'].map(key=>formData[key]).join('_');
    return newFormData;
}

//action
function getData(params, dispatch, form) {
    return http.post(`${API_PREFIX}/list?${qs.stringify(params)}`, form)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}
export function getFormData(query, filterList) {
    const form = {
        "logic": "and",
        "filters": []
    }
    const keys = Object.keys(query).filter(item => !_.includes(['isOnlyShowMe'], item));
    keys.forEach(key=>{
        if (query[key]) {
            form.filters.push({
                "field": key,
                "operator": filterList.find(item=>item.value === key).operator,
                "value": query[key]
            })
        }
    })
    const userInfo = http.getUserInfo();
    console.info(userInfo)
    if (query.isOnlyShowMe) {
        form.filters.push({
            "logic": "or",
            "filters": [
                {"field": "accountId", "operator": "eq", "value": userInfo.user.id},
                {"field": "currentAccountId", "operator": "eq", "value": userInfo.user.id},
            ]
        })
    }
    return form;
}

export function getList() {
    return (dispatch,getState) => {
        const {orderJzhz: {page, query, filterList}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        const form = getFormData(query, filterList);
        getData(data, dispatch, form)
    };
}

export function add(formData) {
    return (dispatch, getState) => {
        formData.domain = formData.domain ? formData.domain.toLowerCase() : formData.domain;
        formData.referDomain = window.location.host;
        return http.post(`${API_PREFIX}/add`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function remove(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function update(formData) {
    return (dispatch, getState) => {
        formData.domain = formData.domain ? formData.domain.toLowerCase() : formData.domain;
        return http.post(`${API_PREFIX}/update/${formData.id}`, trimForm(formData))
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
                dispatch(getStatusDetail());
            })
    }
}

export function showUpdateModal(id, disabled = false) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'update', id, disabled})
            })
    }
}

export function showFlowModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/flow/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_FLOW_DETAIL, flowDetail: data.data})
                dispatch({type: SHOW_MODAL, key: 'flow', id})
            })
    }
}

export function showRefundModal(id) {
    return (dispatch, getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'refund', id})
            })
    }
}

export function getStatusDetail() {
    return (dispatch,getState) => {
        const {orderJzhz: {query}} = getState()
        return http.get(`${API_PREFIX}/status?isOnlyShowMe=${query.isOnlyShowMe}`)
            .then((data) => {
                dispatch({
                    type: RECEIVE_STATUS_DETAIL,
                    data: (data.data || []).reduce((previous, current) => {
                        previous[current[0]] = current[1];
                        previous['全部'] = previous['全部'] + current[1]; 
                        return previous;
                    }, {'全部': 0})
                })
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        add: false,
        delete: false,
        update: false,
        refund: false,
        flow: false,
        id: null,
        disabled: false
    },
    detail: {},
    flowDetail: {
        list: []
    },
    filterList: [
        {"name": "客户旺旺号", "componentType": "Text", "data": [], "isShow": false, "value": "aliwangwang", "operator": "contains"},
        {"name": "客户手机号", "componentType": "Text", "data": [], "isShow": false, "value": "phone", "operator": "contains"},
        {"name": "客户邮箱", "componentType": "Text", "data": [], "isShow": false, "value": "email", "operator": "contains"},
        {"name": "客户域名", "componentType": "Text", "data": [], "isShow": false, "value": "domain", "operator": "contains"},
        {"name": "客户选择套餐", "componentType": "Select", "data": [{"name":"H5企业版550","value":"H5企业版550"},{"name":"H5商城850","value":"H5商城850"},{"name":"H5企业(不带服务器)500","value":"H5企业(不带服务器)500"},{"name":"H5商城(不带服务器)750","value":"H5商城(不带服务器)750"},{"name":"H5企业(带小程序)800","value":"H5企业(带小程序)800"},{"name":"H5商城(带小程序)1450","value":"H5商城(带小程序)1450"}], "isShow": false, "value": "customer_plan", "operator": "eq"},
        {"name": "模板编号", "componentType": "Text", "data": [], "isShow": false, "value": "template_number", "operator": "contains"},
        {"name": "证件类型", "componentType": "Select", "data": [{"name":"营业执照","value":"营业执照"},{"name":"身份证","value":"身份证"}], "isShow": false, "value": "cid_type", "operator": "eq"},
        {"name": "下单日期", "componentType": "Datetime", "data": [], "isShow": false, "value": "order_time", "operator": "eq"},
        {"name": "是否需要装修", "componentType": "Select", "data": [{"name":"是","value":false},{"name":"否","value":false}], "isShow": false, "value": "is_need_decoration", "operator": "eq"},
        {"name": "售前备注", "componentType": "Textarea", "data": [], "isShow": false, "value": "preSaleRemarks", "operator": "contains"},
        {"name": "售后备注", "componentType": "Textarea", "data": [], "isShow": false, "value": "after_sale_remarks", "operator": "contains"},
        {"name": "订单状态", "componentType": "Select", "data": [{"name":"新增","value":"新增"},{"name":"域名注册中","value":"域名注册中"},{"name":"域名模板注册中","value":"域名模板注册中"},{"name":"建站中","value":"建站中"},{"name":"发送邮件中","value":"发送邮件中"},{"name":"等待域名解析","value":"等待域名解析"},{"name":"域名解析中","value":"域名解析中"},{"name":"等待域名所有人变更","value":"等待域名所有人变更"},{"name":"域名所有人变更中","value":"域名所有人变更中"},{"name":"完成","value":"完成"},{"name":"退款中","value":"退款中"},{"name":"退款审核","value":"退款审核"},{"name":"退款完成","value":"退款完成"},{"name":"错误","value":"错误"}], "isShow": false, "value": "status", "operator": "eq"},
        {"name": "是否软件自动", "componentType": "Select", "data": [{"name":"是","value":false},{"name":"否","value":false}], "isShow": false, "value": "is_auto", "operator": "eq"},
        {"name": "FTP用户名", "componentType": "Text", "data": [], "isShow": false, "value": "customerFtpName", "operator": "contains"},
        {"name": "FTP密码", "componentType": "Text", "data": [], "isShow": false, "value": "customerFtpPassword", "operator": "contains"},
        {"name": "模糊查询", "componentType": "Text", "data": [], "isShow": true, "value": "indexField", "operator": "contains", "hideCancelBtn": true},
        {"name": "来源", "componentType": "Select", "data": [{"name":"双德","value":"app.sungdell.com"},{"name":"纸圭","value":"zhigui.sungdell.com"}], "isShow": true, "value": "referDomain", "operator": "eq"},
    ],
    query: {
        status: '',
        isOnlyShowMe: false
    },
    statusDeatial: {}
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id, disabled}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id, disabled}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_FILTER_LIST]: (state,{value}) => {
        return {...state,filterList: value}
    },
    [CHANGE_QUERY]: (state,{key,value}) => {
        return {...state,query: {...state.query,[key]: (value && value.trim) ? value.trim(): value}, page: {index: 0, size: DEFAULT_SIZE}}
    },
    [RECEIVE_DETAIL]: (state, {detail}) => {
        return {...state, detail}
    },
    [RECEIVE_FLOW_DETAIL]: (state, {flowDetail}) => {
        return {...state, flowDetail}
    },
    [RECEIVE_STATUS_DETAIL]: (state,{data}) => {
        return {...state, statusDeatial: {...data}}
    },
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/order_jzhz/reducers/list.js